export function isValidPostelCode(postelCode) {
  return postelCode ? (postelCode.length > 0 || "Postel Code is required") : "Postel Code is required"
}

export const rules = [isValidPostelCode]
